import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.RestoreArchivedFiles.title',
    defaultMessage: 'Restore archived files',
  },
  confirm: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.RestoreArchivedFiles.confirm',
    defaultMessage: 'Do you want to restore/unarchive files on this order?',
  },
  success: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.RestoreArchivedFiles.success',
    defaultMessage: 'Restoring all files. You will be notified in 1-5 minutes when the restore is done.',
  },
  error: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.RestoreArchivedFiles.error',
    defaultMessage: 'Restoring failed. Please contact support.',
  },
})
